export default "__VITE_ASSET__CHqTS6bC__"